document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.site-nav.style--classic .has-submenu.focus').forEach((item) => {
    item.classList.remove('focus');
    item.setAttribute('aria-expanded', 'false');
    item.querySelector(':scope > .menu-link')?.focus();
  });
});

document.addEventListener('focusin', (event) => {
  document.querySelectorAll('.site-nav.style--classic .has-submenu.focus').forEach((item) => {
    if (item.contains(event.target)) return;
    item.classList.remove('focus');
    item.setAttribute('aria-expanded', 'false');
  });
});
